"use client"

import type { FunctionComponent, PropsWithChildren } from "react"

import classNames from "classnames"

import { Button } from "@jobteaser/spark/components/Button"
import { FlagOutlined } from "@jobteaser/spark/components/Icons/FlagOutlined"
import { Printer } from "@jobteaser/spark/components/Icons/Printer"

import { usePageLayoutContext } from "@/modules/jobAdDetail/components/PageLayout/PageLayoutContext"
import { LayoutChild } from "@/modules/layouts/components/Layout/LayoutChild"

import styles from "./PageFooter.module.css"

type PageFooterProps = PropsWithChildren<{
  className?: string
  printLabel: string
  reportLabel: string
}>

export const PageFooter: FunctionComponent<PageFooterProps> = ({ children, className, printLabel, reportLabel }) => {
  const { openReportFlow, printJobAd } = usePageLayoutContext()

  return (
    <LayoutChild as="footer" className={classNames(className, styles.main)} variant="large">
      <div className={styles.mainActions}>
        <Button
          icon={FlagOutlined}
          variant="secondary"
          onClick={() => openReportFlow()}
          className={styles.mainActions__button}
          data-testid="jobad-DetailView__FooterActions__report"
        >
          {reportLabel}
        </Button>
        <Button
          icon={Printer}
          variant="secondary"
          onClick={() => printJobAd()}
          className={styles.mainActions__button}
          data-testid="jobad-DetailView__FooterActions__print"
        >
          {printLabel}
        </Button>
      </div>
      <div className={styles.actionsForDesktop}>{children}</div>
    </LayoutChild>
  )
}
